import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { Tooltip } from 'modules/Core/Common';
import * as S from './styles';

const ValueContainer = ({ children, hasValue, getValue, ...props }) => {
  // eslint-disable-line
  if (!hasValue) {
    return (
      <components.ValueContainer {...props}>
        {children}
      </components.ValueContainer>
    );
  }

  const OPTIONS_LIMIT = 1;
  const [options, otherChildren] = children;
  const overflowCounter = getValue().length;
  const displayOptions = options.slice(0, OPTIONS_LIMIT);

  return (
    <components.ValueContainer {...props}>
      <Tooltip
        placement="top"
        disabled={!getValue().length}
        overlay={
          getValue().length && (
            <S.TooltipDetails>
              {getValue().map(({ name }, index) => (
                <p key={index}>{name}</p>
              ))}
            </S.TooltipDetails>
          )
        }
      >
        <S.SelectValueContainer>
          {displayOptions}
          <span style={{ display: 'block', marginLeft: '8px' }}>
            {overflowCounter > OPTIONS_LIMIT &&
              `+${overflowCounter - OPTIONS_LIMIT}`}
          </span>
          {otherChildren}
        </S.SelectValueContainer>
      </Tooltip>
    </components.ValueContainer>
  );
};

ValueContainer.propTypes = {
  children: PropTypes.node,
  hasValue: PropTypes.bool,
  getValue: PropTypes.func,
};

export default ValueContainer;
